import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line object-curly-newline
import { Typography, TextField, Grid, Box } from '@material-ui/core';
import MuiPhoneNumber from 'material-ui-phone-number';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';
import DesignAndLanguages from '../../components/DesignAndLanguages';
import LogoAndStepper from '../../components/LogoAndStepper';
import TopLayer from '../../components/layers/TopLayer';
import MiddleLayer from '../../components/layers/MiddleLayer';
import BottomLayer from '../../components/layers/BottomLayer';
import ViewPortContainer from '../../components/layers/ViewPortContainer';
import TransitionButtons from '../../components/TransitionButtons';
import BoxContentContainer from '../../components/layers/BoxContentContainer';
import AlternateNumber from './AlternateNumber';
import PlaceOrderDialog from './PlaceOrderDialog';
import SampleOrder from './SampleOrder';
import updateAnalytics from '../../actions/updateAnalytics';

export default function SeamlessForm() {
  // media query, on greater than iphone
  const dispatch = useDispatch();
  const alternateNumber = useSelector(
    (state) => state.formState.Alternate_number
  );
  const placedTestOrder = useSelector(
    (state) => state.formState.Did_place_test_order
  );

  const restaurantId = useSelector((state) => state.formState.Restaurant_id);

  const ownerName = useSelector((state) => state.formState.Owner_name);
  const ownerPhone = useSelector((state) => state.formState.Owner_phone);
  console.log('RENDERED');
  const language = useSelector((state) => state.formState.Page_language);

  useEffect(() => {
    updateAnalytics(
      {
        ownerName,
      },
      restaurantId
    );
    updateAnalytics(
      {
        ownerPhone,
      },
      restaurantId
    );
  }, []);
  return (
    <ViewPortContainer>
      <TopLayer>
        <LogoAndStepper step={3} showStepper />
      </TopLayer>
      <MiddleLayer>
        <BoxContentContainer>
          <Typography variant="h4">
            {translate('Simulate a Customer Order!')}{' '}
          </Typography>
          <Typography variant="h6">
            {' '}
            {language === 'English'
              ? `Upon submitting the test order, you will receive an SMS notification at ${
                  alternateNumber ? alternateNumber : ownerPhone
                }`
              : `提交测试订单后，您将在${
                  alternateNumber ? alternateNumber : ownerPhone
                }收到SMS通知。`}
          </Typography>
          <Box ml={-1}>
            <AlternateNumber />
          </Box>
          <br />{' '}
          <Grid container justify="center">
            <Typography variant="h6">
              <b>{translate('Simulate Order Process')}</b>
            </Typography>
          </Grid>
          <br />
          <SampleOrder />
          <br />
          <Grid container justify="center">
            <PlaceOrderDialog />
          </Grid>
          <br />
          <br />
          <TransitionButtons showBack disabledBack={placedTestOrder} />
          <br />
        </BoxContentContainer>
      </MiddleLayer>

      <BottomLayer>
        <DesignAndLanguages disableDesign showLanguages={false} />
      </BottomLayer>
    </ViewPortContainer>
  );
}
